module.exports = __webpack_public_path__ + "static/img/countdown-bg.06be40be.svg";